import type { ReactNode } from "react";
import { AvatarLabelGroup } from "@/components/base/avatar/avatar-label-group";

export interface TabHeaderProps {
	title: string;
	actions?: ReactNode;
	size?: "sm" | "md" | "lg";
	hideAvatar?: boolean;
	descriptionText?: string;
}

export function TabHeader({
	title,
	actions,
	size = "md",
	hideAvatar = true,
	descriptionText,
}: TabHeaderProps) {
	return (
		<div className="py-2 px-3 min-w-60 md:min-w-50 lg:min-w-100">
			<div className="flex items-center justify-between min-h-[44px]">
				<div className="">
					<AvatarLabelGroup size={size} title={title} hideAvatar={hideAvatar} />
				</div>
				{actions && <div>{actions}</div>}
			</div>
			{descriptionText && (
				<p className="text-sm text-gray-500">{descriptionText}</p>
			)}
		</div>
	);
}
